import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { productsAPI, ordersAPI } from '../../utils/api';
import { FaBox, FaShoppingCart, FaUsers, FaEuroSign, FaExclamationTriangle } from 'react-icons/fa';
import '../../styles/Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState({
    products: null,
    orders: null,
    loading: true
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [productsResponse, ordersResponse] = await Promise.all([
        productsAPI.getStats(),
        ordersAPI.getStats()
      ]);

      setStats({
        products: productsResponse.data.data,
        orders: ordersResponse.data.data,
        loading: false
      });
    } catch (error) {
      console.error('Ошибка загрузки статистики:', error);
      setStats(prev => ({ ...prev, loading: false }));
    }
  };

  if (stats.loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Загрузка статистики...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <div className="dashboard-container">
        <h1>Панель управления</h1>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon products">
              <FaBox />
            </div>
            <div className="stat-info">
              <div className="stat-value">{stats.products?.totalProducts || 0}</div>
              <div className="stat-label">Всего продуктов</div>
              <Link to="/admin/products" className="stat-link">
                Управление продуктами →
              </Link>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon orders">
              <FaShoppingCart />
            </div>
            <div className="stat-info">
              <div className="stat-value">{stats.orders?.totalOrders || 0}</div>
              <div className="stat-label">Всего заказов</div>
              <Link to="/admin/orders" className="stat-link">
                Управление заказами →
              </Link>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon pending">
              <FaExclamationTriangle />
            </div>
            <div className="stat-info">
              <div className="stat-value">{stats.orders?.pendingOrders || 0}</div>
              <div className="stat-label">Ожидают подтверждения</div>
              <Link to="/admin/orders?status=pending" className="stat-link">
                Посмотреть →
              </Link>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon revenue">
              <FaEuroSign />
            </div>
            <div className="stat-info">
              <div className="stat-value">{stats.orders?.totalRevenue?.toFixed(2) || '0.00'} €</div>
              <div className="stat-label">Общая выручка</div>
            </div>
          </div>
        </div>

        <div className="dashboard-sections">
          <div className="dashboard-section">
            <h2>Складская сводка</h2>
            <div className="summary-grid">
              <div className="summary-item">
                <span className="summary-label">Активные продукты:</span>
                <span className="summary-value">{stats.products?.activeProducts || 0}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Нет в наличии:</span>
                <span className="summary-value warning">{stats.products?.outOfStock || 0}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Низкий запас (≤10):</span>
                <span className="summary-value warning">{stats.products?.lowStock || 0}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Стоимость запасов:</span>
                <span className="summary-value">{stats.products?.totalInventoryValue?.toFixed(2) || '0.00'} €</span>
              </div>
            </div>
          </div>

          <div className="dashboard-section">
            <h2>Заказы</h2>
            <div className="summary-grid">
              <div className="summary-item">
                <span className="summary-label">Ожидают подтверждения:</span>
                <span className="summary-value">{stats.orders?.pendingOrders || 0}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Выполнено:</span>
                <span className="summary-value success">{stats.orders?.completedOrders || 0}</span>
              </div>
              <div className="summary-item">
                <span className="summary-label">Отменено:</span>
                <span className="summary-value error">{stats.orders?.cancelledOrders || 0}</span>
              </div>
            </div>
          </div>

          {stats.orders?.popularProducts && stats.orders.popularProducts.length > 0 && (
            <div className="dashboard-section">
              <h2>Популярные продукты</h2>
              <div className="popular-products">
                {stats.orders.popularProducts.slice(0, 5).map((product, index) => (
                  <div key={product._id} className="popular-product-item">
                    <span className="product-rank">#{index + 1}</span>
                    <span className="product-name">{product.name}</span>
                    <span className="product-quantity">{product.totalQuantity} ед.</span>
                    <span className="product-revenue">{product.totalRevenue.toFixed(2)} €</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="quick-actions">
          <h2>Быстрые действия</h2>
          <div className="actions-grid">
            <Link to="/admin/products" className="action-card">
              <FaBox />
              <span>Управление продуктами</span>
            </Link>
            <Link to="/admin/users" className="action-card">
              <FaUsers />
              <span>Управление клиентами</span>
            </Link>
            <Link to="/admin/products" className="action-card">
              <FaBox />
              <span>Управление категориями</span>
            </Link>
            <Link to="/admin/orders?status=pending" className="action-card">
              <FaShoppingCart />
              <span>Ожидающие заказы</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

